import React, { useEffect, useState } from 'react';
import SubUserApi from '../services/subUserApi';
import ConfirmModal from '../components/ConfirmModal';
import { getSubUser,savePromptPay } from '../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// --- Components ย่อยสำหรับ UI ---

// Component สำหรับแสดงสถานะ Loading แบบเต็มหน้าจอ
const LoadingOverlay = () => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="w-16 h-16 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
  </div>
);

// --- หน้า Login หลัก ---

const LoginPage = () => {
  const [username, setUsername] = useState(''); // ค่าเริ่มต้นเป็นค่าว่าง
  const [subUserPassword, setSubUserPassword] = useState(''); // ค่าเริ่มต้นเป็นค่าว่าง
  const [isLoading, setIsLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);


  useEffect(() => {
    const subUser = getSubUser();
    if (subUser) {
      navigateToMain();
      return; 
    }
  }, []);

  const navigateToMain = () => {
    window.location.href = '/main';
  };

  const handleLoginClick = () => {
    // 1. ตรวจสอบข้อมูลเบื้องต้น
    if (!username || !subUserPassword) {
      toast.warn('กรุณากรอกชื่อผู้ใช้และรหัสผ่าน');
      return;
    }

    setIsModalOpen(true);
  };

  const handleConfirmLogin = () => {
    setIsModalOpen(false); 
    login();
  };

  const login = async () => {
    setIsLoading(true); // แสดงสถานะ Loading
    try {
      const response = await SubUserApi.login({ username, subUserPassword });
      const data = response.data;

      if (data.status === 200 && data.data) {
        const { accessToken, refreshToken, subUser } = data.data;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('subUser', JSON.stringify(subUser));

        console.log("ppName : ",subUser.ppName)
        console.log("ppNumber : ",subUser.ppNumber)
        savePromptPay(subUser.ppName,subUser.ppNumber)

        toast.success('เข้าสู่ระบบสำเร็จ');
        setTimeout(navigateToMain, 500); // หน่วงเวลาเล็กน้อยเพื่อให้ user เห็นข้อความ
      } else {
        toast.error(data.message || 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง');
      }
    } catch (error) {
      toast.error('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง');
    } finally {
      setIsLoading(false);
    }
  };

  // --- Rendering UI ---
  return (
    <>
      {/* ToastContainer สำหรับแสดง popup message */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* แสดง Loading Overlay เมื่อ isLoading เป็น true */}
      {isLoading && <LoadingOverlay />}

      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-sm p-5 space-y-4 bg-white rounded-xl md:shadow-lg">
          
          {/* Logo */}
          <img
            src="/images/logo.png" // แก้ไข path ไปยังโลโก้ของคุณ
            alt="Logo"
            className="w-42 h-42 mx-auto "
          />

          {/* Username */}
          <div>
            <label
              htmlFor="username"
              className="text-gray-600 text-center block"
            >
              ชื่อ/User
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-2 mt-2 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Password */}
          <div>
            <label
              htmlFor="password"
              className="text-gray-600 text-center block"
            >
              รหัสผ่าน/Password
            </label>
            <input
              id="password"
              type="password"
              value={subUserPassword}
              onChange={(e) => setSubUserPassword(e.target.value)}
              className="w-full px-4 py-2 mt-2 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Login Button */}
          <button
            onClick={handleLoginClick}
            disabled={isLoading} // ปิดปุ่มเมื่อกำลังโหลด
            className="w-full px-4 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-gray-400"
          >
            {isLoading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
          </button>
        </div>
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        message="หากมีผู้ใช้งานนี้ในอุปกรณ์อื่นที่เข้าระบบอยู่จะออกจากระบบโดยอัตโนมัติ"
        onConfirm={handleConfirmLogin}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default LoginPage;